<template>
    <Frame>
        <PageHeader :title="pageTitle" :hasBack="true" detailType="QuotationDetail" />
        <div class="QuotationDetailHeader" ref="headcontain">
            <div class="buttonlist">
                <span class="messagetitle">{{ $t('comm.messagetitle') }}</span>
                <el-button v-if="PublishState == 1" type="text" :disabled="edit" :class="edit?'button unoption-icon':'button option-icon'" @click="billedit(true)"><svg-icon icon-class="delete" />{{$t('button.delete')}}</el-button>
                <el-button v-if="PublishState == 1" type="text" :disabled="edit" :class="edit?'button unoption-icon':'button option-icon'" @click="billedit()"><svg-icon icon-class="edit" />{{$t('button.modification')}}</el-button>
                <el-button v-if="PublishState == 1" type="text" :disabled="!edit" :class="!edit?'button unoption-icon':'button option-icon'" @click="billsave()"><svg-icon icon-class="save" />{{$t('button.save')}}</el-button>
                <el-button v-if="IsWholeOrderQuote" type="text" :style="(tableData[0]&&tableData[0].AbandonQuote)?'filter:none;color:red':''" :disabled="!edit&&tableData[0]&&!tableData[0].AbandonQuote" :class="(!edit&&tableData[0]&&!tableData[0].AbandonQuote)?'button unoption-icon':'button option-icon'"  @click="ChangeCell('AbandonQuote',tableData[0])"><svg-icon icon-class="abandonQuote" />{{ tableData[0]?(tableData[0].AbandonQuote?$t('QuotationDetail.AbandonedQuote'):$t('QuotationDetail.AbandonQuote')):$t('QuotationDetail.AbandonQuote') }}</el-button>
            </div>
            <div class="head-row" style="justify-content: left;">
                <div class="head-info-cell">{{ $t('QmAbnQlyOrder.BillNo') }}：{{ BillNo }}</div>
                <div class="head-info-cell">{{ $t('Order.messagedate') }}：{{ BillDate }}</div>
                <div class="head-info-cell" v-if="$store.state.ShowComp">{{ $t('Order.compName') }}：{{ CompName }}</div>
                <div class="head-info-cell">{{ $t('QuotationDetail.inquiryPeriod') }}：{{ValidityFromDate+((ValidityFromDate||ValidityToDate)?$t('comm.To'):'')+ValidityToDate }}</div>
                <div class="head-info-cell">{{ $t('QuotationDetail.quotationDeadline') }}：{{ QuoteDdlDate }}</div>
                <div class="head-info-cell">{{ $t('Quotation.purChaseType') }}：
                  <span v-if="BizAttr == '100'">
                    <span>{{ $t('Quotation.productPurchase') }}</span>
                  </span>
                  <span v-else-if="BizAttr == '180'">
                    <span>{{ $t('Quotation.subcontract') }}</span>
                  </span> 
                </div>
                <div class="head-info-cell">{{ $t('Quotation.IsPriceWithTax') }}：{{ IsPriceWithTax?$t('comm.btnyes'):$t('comm.btnno') }}</div>
                <div class="head-info-cell">{{ $t('QuotationDetail.CurrName') }}：{{ CurrName }}</div>   
                <div class="head-info-cell">{{ $t('QuotationDetail.phonenumber') }}：{{ TelNo }}</div>  
                <div class="head-info-cell">{{ $t('QuotationDetail.ConnectAddress') }}：{{ Address }}</div>
                <div class="head-info-cell">{{ $t('QuotationDetail.Remark') }}：{{ Remark }}</div>
                <div class="head-info-cell">{{ $t('Quotation.endQuotationTip') }}：{{ IsEndInquiry?$t('comm.btnyes'):$t('comm.btnno') }}</div>
            </div>
        </div>
        <div class="QuotationDetailBody">
          <div class="BodyTitle">{{ $t('comm.detailtitle')  }}</div>
        </div>
        <el-table ref="multitable" :data="tableData" :height="tableHeight" v-loading="tableLoading" style="margin:0;width:100%" :class="edit?'edittable':''">
        <el-table-column fixed width="50" prop="RowNo" :label="$t('DeliverDetail.number')"></el-table-column>
        <el-table-column fixed :width="WidthControl('MaterialId',tableData)" prop="MaterialId" :label="$t('DeliverDetail.codeid')"></el-table-column>
        <el-table-column fixed :min-width="WidthControl('MaterialName',tableData)" prop="MaterialName" :label="$t('DeliverDetail.name')"></el-table-column>
        <el-table-column fixed :min-width="WidthControl('MaterialSpec',tableData)" prop="MaterialSpec" :label="$t('DeliverDetail.specifications')"></el-table-column>
        <el-table-column fixed :min-width="WidthControl('Quantity&&SUnitName',tableData,5)" prop="Quantity" align="right" :label="$t('QuotationDetail.inquiryNumber')">
          <template slot-scope="scope">
            <span>{{ scope.row.Quantity }}&nbsp{{ scope.row.SUnitName }}</span>
          </template>
        </el-table-column>
        <el-table-column :min-width="WidthControl('Address',tableData,5)" prop="Address" :label="$t('QuotationDetail.DeliveryAddress')"></el-table-column>
        <el-table-column :min-width="WidthControl('Remark',tableData,5)" prop="Remark" :label="$t('QuotationDetail.Remark')"></el-table-column>
        <el-table-column :min-width="90" :label="$t('QuotationDetail.accessory')">
          <template slot-scope="scope">
            <el-button @click="ViewRowAcc(scope.row)" type="text">{{ $t('Quotation.view') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="right" :min-width="WidthControl('SPrice&&CurrName',tableData,7,10)" :label="$t('QuotationDetail.sprice')">
          <template slot-scope="scope">
            <div v-if="edit" style="display: flex;flex-wrap: nowrap;width: 100%;">
              <el-input size="small" class="editinput" @change="SpriceChange(scope.row)" maxlength="19" v-model="scope.row.SPrice"></el-input>
              <span style="width: 40%;margin: auto 0;">{{ scope.row.CurrName }}</span>
            </div>
            <div v-else style="width: 100%;right: 0;word-break: break-all;">
              <span style="margin: auto 0;">{{ scope.row.SPrice }}&nbsp{{ scope.row.SPrice?scope.row.CurrName:'' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :min-width="WidthControl('TaxName',tableData,5,20)"  :label="$t('QuotationDetail.TaxId')">
          <template slot-scope="scope">
              <div :class="edit?'changeCell':''"  @click="ChangeCell('Tax',scope.row)">
                  <svg-icon v-if="edit" class="changeIcon" icon-class="changeaddress-blue" />
                  <span  style="margin:auto 0;width: 97%;">{{ scope.row.TaxName }}</span>
              </div>
          </template>
        </el-table-column>
        <el-table-column align="right" :min-width="WidthControl('OAmountWithTax&&SUnitName',tableData,5,20)" prop="OAmountWithTax"  :label="$t('QuotationDetail.WithTaxPrice')" >
        <template slot-scope="scope">
          <div style="width: 100%;right: 0;word-break: break-all;">
            <span  style="margin: auto 0;text-align: right;">{{ scope.row.OAmountWithTax }}&nbsp{{ (scope.row.OAmountWithTax||scope.row.OAmountWithTax===0)?scope.row.CurrName:'' }}</span>
          </div>
        </template>
        </el-table-column>
        <el-table-column :min-width="WidthControl('DeliveryTypeName',tableData,5,20)" :label="$t('QuotationDetail.DeliveryType')" >
          <template slot-scope="scope">
              <div :class="edit?'changeCell':''"  @click="ChangeCell('DeliveryType',scope.row)">
                  <svg-icon v-if="edit" class="changeIcon" icon-class="changeaddress-blue"  />
                  <span  style="margin:auto 0;width: 97%;">{{ scope.row.DeliveryTypeName }}</span>
              </div>
          </template>
        </el-table-column>
        <el-table-column :min-width="WidthControl('QuoteExplain',tableData,5,20)" prop="QuoteExplain"  :label="$t('QuotationDetail.QuotationExplain')" >
          <template slot-scope="scope">
            <div :class="edit?'changeCell':''" @click="ChangeCell('QuoteExplain',scope.row)">
              <svg-icon v-if="edit" class="changeIcon" icon-class="changeaddress-blue"  />
              <span  style="margin:auto 0;width: 97%;">{{ scope.row.QuoteExplain }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="120" v-if="IsKnowResult" :label="$t('QuotationDetail.QuotationResult')" >
          <template slot-scope="scope">
            <span style="display: flex;" v-if="scope.row.IsKnowResult&&scope.row.UpdatePriceSourceList">
                    <div class="dot greendot"></div>
              <span>{{ $t('QuotationDetail.Selected') }}</span>
            </span>
             <span style="display: flex;" v-else-if="scope.row.IsKnowResult&&!scope.row.UpdatePriceSourceList">
                <div class="dot reddot"></div>
              <span>{{ $t('QuotationDetail.UnSelected') }}</span>
            </span>
           
            <span style="display: flex;" v-else-if="!scope.row.IsKnowResult">
            </span>
          </template>
        </el-table-column>
        <el-table-column v-if="IsKnowResult" :min-width="WidthControl('OrderResult',tableData,8)" prop="OrderResult" :label="$t('QuotationDetail.QuoteResult')"></el-table-column>
        <el-table-column width="120" v-if="!IsWholeOrderQuote" :label="$t('QuotationDetail.GiveUpQuotation')" >
          <template slot-scope="scope">
            <el-button class="abandonBtn" :style="scope.row.AbandonQuote?'color:red':''" :disabled="!edit&&!scope.row.AbandonQuote" @click="ChangeCell('AbandonQuote',scope.row)">
              {{ scope.row.AbandonQuote?$t('QuotationDetail.AbandonedQuote'):$t('QuotationDetail.AbandonQuote') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="DialogTitle" :visible.sync="DialogVisible" width="40%">
            <el-select v-if="SelectTaxId" size="small" v-model="RowTaxId" placeholder="" class="pop-Select">
                <el-option   v-for="item in TaxTable" :key="item.TaxId" :label="item.TaxName" class="option" :value="item.TaxId">
                </el-option>
            </el-select>
            <el-select v-else size="small"  v-model="RowDeliveryType" placeholder="" class="pop-Select">
                <el-option  v-for="item in DeliveryTypeTable" :key="item.DeliveryTypeId" :label="item.DeliveryTypeName" class="option" :value="item.DeliveryTypeId">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="SelectCancel">{{ $t('button.cancel') }}</el-button>
                <el-button type="primary" @click="SelectChange">{{ $t('button.determine') }}</el-button>
            </span>
      </el-dialog>
      <el-dialog :title="ShortMemoDialogTitle" :visible.sync="ShortMemoDialogVisible" width="40%" @closed="ShortMemoClosed">
        <el-input v-if="edit" v-model="ShortMemoText" clearable type="textarea" maxlength="400" :autosize="{minRows:3}"></el-input>
        <span v-else>{{ ShortMemoText }}</span>
        <span v-if="edit" slot="footer" class="dialog-footer">
          <span  style="margin-right: 10px;">{{ ShortMemoText.length+"/400" }}</span>
          <el-button @click="ShortMemoCancel">{{ $t('button.cancel') }}</el-button>
          <el-button type="primary" @click="ShortMemoConfrim">{{ $t('button.determine') }}</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="$t('comm.viewFile')" :visible.sync="rowAccVisible" append-to-body>
          <el-table :data="RowAccTableData"  height="50vh" ref="AccTable" v-loading="AcctableLoading">
              <el-table-column type="index" :label="$t('comm.number')" width="100"></el-table-column>
              <el-table-column prop="AccessoryName" :label="$t('Download.accessoryname')"></el-table-column>
              <el-table-column prop="UploadTime" :label="$t('Download.recupdate')"></el-table-column>
              <el-table-column width="130" :label="$t('DeliverCar.operation')">
                  <template slot-scope="scope">
                      <el-button class="BtnSpan" v-if="hasPreviewPower" @click="PreviewAcc(scope.row)" type="text">{{$t('button.check')}}</el-button>
                      <el-button class="BtnSpan" v-if="hasDownloadPower" @click="loadAcc(scope.row)" type="text">{{$t('button.download')}}</el-button>
                  </template>
                
              </el-table-column>
          </el-table>
      </el-dialog>
    </Frame>
</template>
<script>
import {PreviewAcc,decimalRound,downloadAcc} from '@/utils/utils'
    export default{
      data(){
          return{
              edit:false,
              BillNo:'',
              OrgId:'',
              tableData:[],
              OriginData:[],
              BillDate:'',
              CompName:'',
              ValidityFromDate:'',
              ValidityToDate:'',
              QuoteDdlDate:'',
              IsPriceWithTax:false,
              BizAttr:'',
              TelNo:'',
              Address:'',
              Remark:'',
              tableLoading:false,
              tableHeight:window.innerHeight - 418,
              TaxTable:[],
              DeliveryTypeTable:[],
              RowTaxId:null,
              RowDeliveryType:'',
              SelectTaxId:true,
              DialogVisible:false,
              DialogTitle:'',
              TypeId:'',
              base:{
                progId:'purInquiryDmnIss',
                InternalId:'',
                billNo:''
              },
              primaryKey:{
                billNo:''
              },
              ChangeRow:null,
              pageTitle:this.$t('comm.quotation'),
              ShortMemoDialogTitle:'',
              ShortMemoDialogVisible:false,
              ShortMemoText:'',
              ShortMemoType:'',
              IsWholeOrderQuote:false,//是否整单报价
              AcctableLoading:false,
              RowAccTableData:[],
              rowAccVisible:false,
              hasPreviewPower:false,
              hasDownloadPower:false,
              EditData:[],
              IsEndInquiry:false,
              ExQuoteLimitNum:false,
              IsKnowResult:false,
              PublishState:1,
              CurrId:'',
              CurrName:'',
              RoundType:0,
              AmountDecDigs:0,
              PriceDecDigs:0,
              IsTaxByOrder:false,
              FOrgId:'',
              Calculating:false

          }
      },
      async created(){
        this.BillNo = this.$route.query.BillNo;
        await this.getData();
        if(this.$route.query.edit)
        this.billedit();
      },
      mounted(){
        let that = this;
        that.tableHeight = window.innerHeight - 180 - this.$refs.headcontain.offsetHeight;
        window.onresize = () => {
          if (that.resizeFlag) {
            clearTimeout(that.resizeFlag);
          }
          that.resizeFlag = setTimeout(() => {
    
            that.tableHeight = window.innerHeight - 180 - this.$refs.headcontain.offsetHeight;
            that.resizeFlag = null;
          }, 100);
        }
      },
      methods:{
        async getData(){
          this.tableLoading = true;
          await this.asyncaxiosInvoke(this.sysHandlerUrl, {
            action:'getpurinquirydmnissdetail',
            BillNo:this.BillNo,
          },(res,err)=>{
            if(err){
              this.tableLoading = false;
              return;
            }
            this.tableLoading = false;
            let data = res.data;
            let HeadTable = data.HeadTable;
            this.tableData = data.BodyTable;
            data.BodyTable.forEach(row => {
              let obj = {...row};
              this.OriginData.push(obj);
            });
            this.TaxTable = data.TaxTable;
            this.DeliveryTypeTable = data.DeliveryTypeTable;
            this.OrgId = HeadTable.OrgId;
            this.TypeId = HeadTable.TypeId;
            this.BillDate = HeadTable.BillDate;
            this.CompName = HeadTable.CompName;
            this.FOrgId = HeadTable.FOrgId;
            this.CurrName = HeadTable.CurrName;
            this.CurrId = HeadTable.CurrId;
            this.RoundType = HeadTable.RoundType;
            this.AmountDecDigs = HeadTable.AmountDecDigs;
            this.PriceDecDigs = HeadTable.PriceDecDigs;
            this.IsTaxByOrder = HeadTable.IsTaxByOrder;
            this.ValidityFromDate = HeadTable.ValidityFromDate;
            this.ValidityToDate = HeadTable.ValidityToDate;
            this.QuoteDdlDate = HeadTable.QuoteDdlDate;
            this.IsPriceWithTax = HeadTable.IsPriceWithTax;
            this.BizAttr = HeadTable.BizAttr;
            this.TelNo = HeadTable.TelNo;
            this.Address = HeadTable.Address;
            this.Remark = HeadTable.Remark;
            this.base.InternalId = HeadTable.InternalId;
            this.base.billNo = HeadTable.BillNo;
            this.primaryKey.billNo=HeadTable.BillNo;
            this.IsWholeOrderQuote = HeadTable.IsWholeOrderQuote;
            this.ExDateLimit = HeadTable.ExDateLimit;
            this.IsEndInquiry = HeadTable.IsEndInquiry;
            this.ExQuoteLimitNum = HeadTable.ExQuoteLimitNum;
            this.IsKnowResult = HeadTable.IsKnowResult;
            this.PublishState = HeadTable.PublishState;
            if(this.PublishState!=1){
              this.$store.commit("TIPPOP",{popType:'warning',popMessage:this.$t('QuotationDetail.PublishStateErr')});
            }
            this.$nextTick(()=>{
              this.$refs.multitable.doLayout();
              this.tableHeight = window.innerHeight - 180 - this.$refs.headcontain.offsetHeight;
            })
          });
        },
        //修改订单信息
        billedit(isDelete){
          this.tableLoading = true;
          this.axiosInvoke("/SupplierComm/Handler/OrderPurPurchaseHandler.ashx", {
              action:"ispermitedit",
              ProgId:'purInquiryDemand',
              BillNo:this.base.billNo,
            },(res,errflag)=>{
              this.tableLoading = false;
              if(!errflag&&!this.ExDateLimit&&!this.IsEndInquiry&&!this.ExQuoteLimitNum){
                if(!isDelete){
                  this.edit = true;
                  this.pageTitle = this.$t('QuotationDetail.inquiryEdit');
                  this.$refs.multitable.doLayout();
                }else{
                  //删除报价信息逻辑
                  this.$confirm(this.$t("QuotationDetail.DeleteQuoteInfo"),this.$t("comm.tip"),
                  {
                    confirmButtonText:this.$t("comm.confirm"),
                    cancelButtonText:this.$t("comm.GiveUp"),
                    type:'warning'
                  }).then(()=>{
                    this.axiosInvoke(this.sysHandlerUrl,{
                      action:'delwebquote',
                      BillNo:this.BillNo,
                    },(res,err)=>{
                      if(!err){
                        this.$store.commit("TIPPOP",{popType:'success',popMessage:this.$t('QuotationDetail.DeleteQuoteSuccess')});
                        this.getData();
                      }
                    }
                    )
                  }).catch(()=>{
                  })       
                }
              }else if(this.IsEndInquiry){//报价已终止
                this.$store.commit("TIPPOP",{popType:'warning',popMessage:this.$t('QuotationDetail.IsEndInquiryTip')});
              }
              else if(this.ExDateLimit){//超出截止日期
                this.$store.commit("TIPPOP",{popType:'warning',popMessage:this.$t('QuotationDetail.ExceedTheDateLimit')});
              }
              else if(this.ExQuoteLimitNum){//超出报价次数
                this.$store.commit("TIPPOP",{popType:'warning',popMessage:this.$t('QuotationDetail.ExQuoteLimitNumTip')});
              }
            });
        },
         

        /**
         * 保存单据的前置动作
         */
        billsave(){
          if(this.Calculating){
            let that = this;
            setTimeout(()=>{
              that.billsave();
            },300)
          }
          let haveUnEdit = false;
          let that = this;
          function checkFullEdit(DataList){
            DataList.forEach((v)=>{
              if(!v.AbandonQuote){
                //检测是否有内容未填写
                if(v.SPrice==""||v.TaxId==""){
                  haveUnEdit = true;
                  that.$store.commit("TIPPOP",{popType:'warning',popMessage:that.$t("QuotationDetail.CheckEditRowTip").replace('{0}',v.RowNo)}); 
                  return
                }
              }
            })
          }
          
          if(this.IsWholeOrderQuote){
            checkFullEdit(this.tableData);
            if(haveUnEdit){
              this.$confirm(this.$t("QuotationDetail.NeedWholeQuotation"),this.$t("comm.tip"),
                  {
                    confirmButtonText:this.$t("comm.confirm"),
                    cancelButtonText:this.$t("comm.GiveUp"),
                    type:'warning'
                  }).then(()=>{}).catch(()=>{
                  })
            }else{
              this.saveSumbit();
            }
          }
          else{
            checkFullEdit(this.EditData);
            if(!haveUnEdit){//若没有行项未编辑，允许保存
              this.saveSumbit();
            }
          }
        },

        /**
         * 处理提交保存单据请求的方法
         */
        saveSumbit(){
            this.edit = false;
            this.tableLoading = true;
            if(this.EditData.length==0){
              this.tableLoading = false;
              return;
            }
            this.axiosInvoke(this.sysHandlerUrl, 
            {
              action:'updatewebquote',
              BillNo:this.BillNo,
              UpdateInfo:JSON.stringify(this.EditData),
            },(res,err)=>{
              if(!err){
                this.tableLoading = false;
                this.EditData = [];
                this.getData();
              }else{
                this.tableLoading = false;
                this.getData();
              }
            });
        },
        SpriceChange(row){
          const regex = /^(\d{1,3}(,\d{3})*(\.\d+)?|\d+(\.\d+)?)$/;
          let fieldValue = String(row.SPrice);
          let Qty = String(row.Quantity).replace(/,/g,"");
          if(regex.test(fieldValue)){
           row.SPrice = decimalRound(Number(fieldValue),this.PriceDecDigs,this.RoundType).toFixed(this.PriceDecDigs);
            //如果当前行项已经变成已放弃报价
            if(row.AbandonQuote){
              //判断是否整单报价
              let TipInfo = this.$t('QuotationDetail.CancelAbandonQuoteTip');
              if(this.IsWholeOrderQuote){
                TipInfo = this.$t('QuotationDetail.CancelWholeAbTip');
              }
              this.$confirm(TipInfo,this.$t("comm.tip"),
                {
                  confirmButtonText:this.$t("comm.confirm"),
                  cancelButtonText:this.$t("comm.cancelText"),
                  type:'warning'
                }).then(()=>{
                  if(this.IsWholeOrderQuote){
                    this.tableData.forEach((v)=>{
                      v.AbandonQuote = false;
                      v.AbandonQuoteReason = "";
                    })
                  }
                  row.AbandonQuote =false; 
                  row.AbandonQuoteReason = "";    
                  if(row.TaxId&&row.TaxId!=""){
                    this.rowCalculate(row);
                  }
                  this.RecoredRowChange(row);
                  this.$message({
                    type:'success',
                    message:this.$t('comm.EditSuccess')
                  })
                }).catch(()=>{
                  this.OriginData((v)=>{
                    if(v.RowCode == row.RowCode){
                      row.SPrice = v.SPrice;
                    }
                  })
                })
            }else{
              if(row.TaxId&&row.TaxId!=""){
                this.rowCalculate(row);
              }
              this.RecoredRowChange(row);
            }
          }else{
            row.SPrice = "";
            row.OAmountWithTax = "";
            row.OTax = "";
            row.OAmount = "";
            this.$store.commit("TIPPOP",{popType:'warning',popMessage:this.$t("QuotationDetail.SpriceTip")});
          }
        },
        rowCalculate(row){
          this.Calculating = true;
          this.axiosInvoke(this.sysHandlerUrl,{
            action:'purinquirydmnisscal',
            SPrice:row.SPrice,
            TaxRate:row.TaxRate,
            Quantity:row.Quantity,
            IsPriceWithTax:this.IsPriceWithTax,
            FOrgId:this.FOrgId,
            CurrId:this.CurrId,
            IsTaxByOrder:this.IsTaxByOrder,
            IsDecutRateTax:row.IsDecutRateTax,
          },(res)=>{
            this.Calculating = false;
            let data = res.data;
            row.OAmountWithTax = data.OAmountWithTax;
            row.OAmount = data.OAmount;
            row.OTax = data.OTax; 
          })
        },
        ChangeCell(changekind,row){
          if(!this.edit&&changekind!="AbandonQuote")return;
          this.ChangeRow = row;
          switch(changekind){
            case "Tax":
              this.DialogVisible = true;
              this.RowTaxId = row.TaxId;
              this.DialogTitle = this.$t("QuotationDetail.SelectTax");
              this.SelectTaxId = true;
              break;
            case "DeliveryType":
              this.DialogVisible = true;
              this.RowDeliveryType = row.DeliveryTypeId
              this.DialogTitle = this.$t("QuotationDetail.SelectDeliveryType");
              this.SelectTaxId = false;
              break;
            case "QuoteExplain":
              this.ShortMemoDialogTitle = this.$t('QuotationDetail.QuotationExplain');
              this.ShortMemoDialogVisible = true;
              this.ShortMemoText = row.QuoteExplain;
              this.ShortMemoType = changekind;
              break;
            case "AbandonQuote":
              this.ShortMemoDialogTitle = this.$t('QuotationDetail.AbandonQuoteReason');
              this.ShortMemoDialogVisible = true;
              this.ShortMemoText = row.AbandonQuoteReason;
              this.ShortMemoType = changekind;
              break;
          }
        },
        
        SelectCancel(){
          this.DialogVisible = false;
        },
        SelectChange(){
          if(!this.SelectTaxId)
          {
            this.ChangeRow.DeliveryTypeId = this.RowDeliveryType;
            let DeliveryTypeName = "";
            this.DeliveryTypeTable.forEach((v)=>{
              if(this.RowDeliveryType == v.DeliveryTypeId){
                DeliveryTypeName = v.DeliveryTypeName;
                return
              }
            })
            this.ChangeRow.DeliveryTypeName = DeliveryTypeName;
          }
          else{
            this.ChangeRow.TaxId = this.RowTaxId;
            this.TaxTable.forEach((v)=>{
              if(this.RowTaxId == v.TaxId){
                this.ChangeRow.TaxName = v.TaxName;
                this.ChangeRow.TaxRate = v.TaxRate;
                this.ChangeRow.IsDecutRateTax = v.IsDecutRateTax;
                if(this.ChangeRow.SPrice&&this.ChangeRow.SPrice!=""){
                  this.rowCalculate(this.ChangeRow);
                }
                return;
              }
            })
          }
          this.RecoredRowChange(this.ChangeRow)
          this.DialogVisible = false;
              
        },
        ShortMemoCancel(){
          this.ShortMemoDialogVisible = false;
        },
        ShortMemoConfrim(){
          switch(this.ShortMemoType){
            case 'QuoteExplain':
              this.ChangeRow.QuoteExplain = this.ShortMemoText;
              break;
            case "AbandonQuote":
              this.ChangeRow.AbandonQuoteReason = this.ShortMemoText;
              //整单报价的情况下，放弃所有物料的报价
              if(this.IsWholeOrderQuote){
                this.tableData.forEach((v)=>{ 
                  v.AbandonQuote = true;
                  v.AbandonQuoteReason = this.ShortMemoText;
                  this.RecoredRowChange(v);
                })
              }
              this.ChangeRow.AbandonQuote = true;
              break;
          }
          this.RecoredRowChange(this.ChangeRow);
          this.ShortMemoDialogVisible = false;
          
        },
        ShortMemoClosed(){
          this.ShortMemoText ="";
        },
        loadAcc(row){
            downloadAcc.call(this,this.base.progId,this.base.InternalId,this.primaryKey,row);
        },
        ViewRowAcc(row){
          this.AcctableLoading = true;
          this.rowAccVisible = true;
          this.RowAccTableData = [];
          this.axiosInvoke("/SupplierComm/Handler/VueSysHandler.ashx",
          {
            action:'getpurinquirydmnissrowacc',
            InternalId:this.base.InternalId,
            RowCode:row.RowCode,
            MaterialId:row.MaterialId,
            OrgId:this.OrgId,
            BillNo:this.BillNo,
            TypeId:this.TypeId
          },
          (res)=>{
            let data = res.data;
            this.hasPreviewPower = data.hasPreviewPower;
            this.hasDownloadPower=data.hasDownloadPower;
            this.RowAccTableData = data.AccTable;
            this.AcctableLoading = false;
          }
          )
        },
        PreviewAcc(row){
          PreviewAcc(row.AccessoryId);
        },
        RecoredRowChange(row){
          let isExist = false;
          for(let i = 0;i<this.EditData.length;i++){
            if(this.EditData[i].RowCode === row.RowCode){
              isExist = true;
              this.EditData[i] = row;
              console.log(this.EditData);
              return;
            }
          }
          if(!isExist){
            this.EditData.push(row);
            console.log(this.EditData);
          }
        }
      }
    }
</script>
<style scoped>
.QuotationDetailHeader{
    color: #777777;
    font-size: 14px;
    width: calc( 100% - 20px);
    padding: 24px 10px 0 10px;
}
.buttonlist{
    display: flex;
}
.button {
  white-space: nowrap;
  color: #5d5d5d;
  font-size: 15px;
  cursor: pointer;
}
.messagetitle {
  color: #5d5d5d;
  font-size: 16px;
  width: 70%;
  padding: 0 20px;
}
.button:hover {
  cursor: pointer;
  color: #0177d5;
}
.option-icon{
  filter: grayscale(100%);
  margin:0 2.5%;
}
.unoption-icon{
  filter: grayscale(100%);
  margin:0 2.5%;
  opacity: 0.5;
}
.option-icon:hover{
  filter: grayscale(0%);
}
.head-row{
    padding: 0 20px 14px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.head-info-cell{
    color: #777777;
    font-size: 14px;
    width: 31%;
    padding-right: 1%;
    word-break: break-all;
    padding-top: 14px;
    overflow: auto;
    max-height: 100px;

}
.BodyTitle{
    color: #5d5d5d;
    font-size: 16px;
    width: 60%;
    padding: 0 30px;
}
.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}

.el-table /deep/ .el-table__body-wrapper,.el-table /deep/ .el-table__fixed-body-wrapper {
  font-size: 13px;
}

.el-table /deep/ thead {
  font-size: 14px;
  color: #777777;
}
.edittable /deep/ .el-table__row{
  background-color:#f4f9ff;
}
.changeCell{
  display: flex;
  min-height: 30px;
  margin: auto 0;
  flex-wrap: nowrap;
}
.changeCell:hover{
    color: #409EFF;
    cursor: pointer;
}
.changeIcon{
    filter: grayscale(1);
    margin: auto 2px;
    width: 16px;
    height: 16px;
}
.changeCell:hover .changeIcon{
    filter: grayscale(0);
}
.editinput{
  margin: auto 0;
  min-width: 70px;
  width: 60%;
}
.pop-Select{
    width: 90%;
    margin: 0 5%;
}
.abandonBtn{
  padding: 8px 10px;
}
.QuoteExplainInput{
  width: 100%;
}
.dot{
    width: 5px;
    height: 5px;
    border-radius: 3px;
    margin: auto 7px auto 0;
}
.greendot{
    background-color: rgb(10, 223, 10);
}
.reddot{
    background-color: red;
}
</style>